import { UserI } from "@services/getUsers";
import {
  ActionBaseUser,
  ActionEditUserColor,
  ActionSetUsers,
  ActionTypesUsersE,
} from "./actionTypes";

interface UsersStateI {
  initialized: boolean;
  users: UserI[];
}

const initialState: UsersStateI = {
  initialized: false,
  users: [],
};

const usersReducer = (
  state: UsersStateI = initialState,
  action: ActionBaseUser
): UsersStateI => {
  switch (action.type) {
    case ActionTypesUsersE.SET_USERS:
      const { users } = (action as ActionSetUsers).payload;
      return {
        ...state,
        initialized: true,
        users,
      };

    case ActionTypesUsersE.CLEAR_USERS:
      return {
        ...state,
        initialized: false,
        users: [],
      };

    case ActionTypesUsersE.EDIT_USER_COLOR:
      const editedUser = (action as ActionEditUserColor).payload;
      const index = state.users.findIndex((u) => u.id === editedUser.id);
      return {
        ...state,
        initialized: false,
        users: [
          ...state.users.slice(0, index),
          editedUser,
          ...state.users.slice(index + 1),
        ],
      };

    default:
      return state;
  }
};

export default usersReducer;
